<script setup>

import {onMounted, ref} from "vue";

const props = defineProps({
    courseId: {
        type: Number,
        required: true
    }
})

const course = ref(null)

const loadCourse = async () => {
    const res = await axios.get(route('api.course.customerarea.show', props.courseId))
    course.value = res.data.course
}

const handleChapterCompletion = (chapter) => {
    console.log('asdasd')
    const courseChapters = course.value.chapters
    const chapterIndex = courseChapters.findIndex(c => c.id === chapter.id)
    course.value.chapters[chapterIndex].completed = chapter.completed
    console.log(chapter)
}

onMounted(() => {
    loadCourse()
})

</script>
<template>
    <div
        v-if="course"
        class="flex items-stretch min-h-screen"
        :class="'course-id-' + courseId"
    >
        <course-chapter-navigation-modal
            :course-id="courseId"
            @chapter-completion-update="handleChapterCompletion"
        ></course-chapter-navigation-modal>
        <div class="w-full max-w-5xl mx-auto mt-12 lg:mt-24">
            <h1>{{ course.title }}</h1>
            <div v-if="course.description"
                 v-html="course.description"
            ></div>

            <ul class="grid items-stretch sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
                <li
                    v-for="(chapter, i) in course.chapters"
                    :key="chapter.id"
                >
                    <card-basic :compact="true" margin-bottom-class="mb-0" class="min-h-full">
                        <div
                            v-if="chapter.thumbnail_url"
                            class="mb-2 -mx-4 -mt-4"
                        >
                            <img
                                :src="chapter.thumbnail_url"
                                class="aspect-video object-contain "
                                alt=""
                            />
                        </div>
                        <div class="leading-5">
                            <a
                                v-if="chapter.published && (chapter.available || course.chapters[i - 1]?.completed)"
                                :href="route('course.customerarea.chapter.show', [course.id, chapter.id])"
                                class="text-inherit text-xs mf-link-immune"
                                :class="chapter.id === currentChapterId ? 'font-bold' : ''"
                            >
                                <div class="font-bold text-sm">{{ chapter.title }}</div>
                                <div
                                    v-if="chapter.description"
                                    class="mt-1 w-full whitespace-pre-wrap"
                                >
                                    {{ chapter.description }}
                                </div>
                                <span
                                    v-if="chapter.id === currentChapterId"
                                    class="absolute right-full top-1 bottom-1 bg-wlPrimary w-1 -translate-x-1 rounded-wl"
                                ></span>
                            </a>
                            <span
                                v-else
                                class="text-gray-400 cursor-not-allowed text-xs"
                            >
                                <div class="font-bold text-sm">{{ chapter.title }}</div>
                                <div
                                    v-if="chapter.description"
                                    class="mt-1 w-full whitespace-pre-wrap"
                                >
                                    {{ chapter.description }}
                                </div>
                            </span>
                            <div class="border-t flex justify-between items-center mt-2 pt-2">
                                <div>
                                    <span
                                        v-if="course.has_multiple_providers && chapter.provider"
                                        class="text-gray-400 text-xs"
                                    >{{ _mft('shared:by') }} {{ chapter.provider.name }}</span>
                                </div>
                                <span v-if="chapter.completed" class="flex items-center">
                                    <span
                                        class="inline-block w-4 h-4 relative"
                                    >
                                        <span
                                            class="border-2 absolute transition-all rounded-full bg-myflowGreen border-myflowGreen -inset-px opacity-70"
                                        >
                                            <span
                                                class="flex items-center justify-center absolute inset-0 transition-all duration-75"
                                            >
                                                <i class="fa-solid fa-check text-white m-auto" style="font-size: 10px"></i>
                                            </span>
                                        </span>
                                    </span>
                                    <span class="text-xs text-gray-400 ml-1">{{ _mft('shared:done') }}</span>
                                </span>
                            </div>
                        </div>
                    </card-basic>
                </li>
            </ul>
        </div>


    </div>
    <div v-else class="flex justify-center mt-24">
        <mf-spinner-medium class="w-24 h-12" />
    </div>
</template>
